import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
Vue.use(VueCompositionAPI);

import App from './App.vue'

let container = document.getElementById("solution-selector");
new Vue({
    el: "#solution-selector",
    data: {
        solutionid: container.dataset.solution,
        storename: container.dataset.storename,
        validation: container.dataset.validation,
        errorMessage: container.dataset.errormessage
    },
    components: { App },
    template: "<App/>"
});
